module.exports = __webpack_public_path__ + "img/f3.a60cc012.jpeg";